export default __webpack_public_path__ + "static/media/caption-2-min.2ee59266.jpg";